"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSupportedSDKFile = exports.getUploadTexts = exports.getPlatformTypeName = exports.default = exports.SDK_FILE_EXTENSIONS = exports.PLATFORM_TYPES = void 0;
var _components = require("@/components");
var _vuex = require("vuex");
var _validators = require("vuelidate/lib/validators");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PLATFORM_TYPES = exports.PLATFORM_TYPES = [{
  id: 'web',
  name: 'Web'
}, {
  id: 'android',
  name: 'Android'
}, {
  id: 'ios',
  name: 'iOS'
}, {
  id: 'windows',
  name: 'Windows'
}, {
  id: 'macos-arm64',
  name: 'macOS (Apple Silicon)'
}, {
  id: 'macos-x64',
  name: 'macOS (Intel)'
}, {
  id: 'digital-certificate',
  name: 'Certificado Digital'
}];
var getPlatformTypeName = exports.getPlatformTypeName = function getPlatformTypeName(platformType) {
  var platform = PLATFORM_TYPES.find(function (item) {
    return item.id === platformType;
  });
  return platform ? platform.name : platformType;
};
var getUploadTexts = exports.getUploadTexts = function getUploadTexts(platformType) {
  if (platformType === 'digital-certificate') {
    return {
      version: 'Versão do certificado digital',
      dropzone: 'Busque ou arraste o certificado digital',
      required: 'O arquivo do certificado digital é obrigatório',
      invalidFormat: 'Formato de certificado digital não suportado.',
      success: 'Certificado digital enviado com sucesso!',
      error: 'Erro ao enviar o certificado digital.'
    };
  }
  return {
    version: 'Versão do SDK',
    dropzone: 'Busque ou arraste o SDK',
    required: 'O arquivo SDK é obrigatório',
    invalidFormat: 'Formato de SDK não suportado.',
    success: 'SDK enviado com sucesso!',
    error: 'Erro ao enviar o SDK.'
  };
};
var SDK_FILE_EXTENSIONS = exports.SDK_FILE_EXTENSIONS = ['.aar', '.js', '.framework', '.xcframework', '.dll', '.exe', '.msi', '.dylib', '.dmg', '.pkg', '.pfx', '.p12', '.cer', '.crt', '.pem', '.der', '.p7b', '.zip', '.rar', '.7z', '.tar', '.gz', '.tgz', '.bz2', '.xz'];
var isSupportedSDKFile = exports.isSupportedSDKFile = function isSupportedSDKFile(file) {
  if (!file) return true;
  var fileName = (file.name || '').toLowerCase();
  return SDK_FILE_EXTENSIONS.some(function (extension) {
    return fileName.endsWith(extension);
  });
};
var _default = exports.default = {
  name: 'ModalUploadSDK',
  components: {
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect
  },
  props: {
    idService: {
      type: String,
      required: true
    },
    getListSDKs: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      file: null,
      findFile: false,
      loading: false,
      listPlatformType: PLATFORM_TYPES,
      form: {
        version: '',
        platformType: '',
        file: null
      }
    };
  },
  computed: {
    uploadTexts: function uploadTexts() {
      return getUploadTexts(this.form.platformType);
    },
    acceptedFileTypes: function acceptedFileTypes() {
      return SDK_FILE_EXTENSIONS.join(',');
    }
  },
  validations: function validations() {
    return {
      form: {
        version: {
          required: _validators.required
        },
        platformType: {
          required: _validators.required
        },
        file: {
          required: _validators.required,
          supportedFormat: isSupportedSDKFile
        }
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['uploadSDK'])), {}, {
    close: function close() {
      this.$parent.close();
    },
    showInvalidFileMessage: function showInvalidFileMessage() {
      this.$buefy.toast.open({
        message: this.uploadTexts.invalidFormat,
        position: 'is-top',
        type: 'is-danger'
      });
    },
    saveSDK: function () {
      var _saveSDK = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var payload, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              e.preventDefault();
              this.$v.form.$touch();
              if (this.$v.$invalid) {
                _context.n = 6;
                break;
              }
              this.loading = true;
              payload = {
                digitalAsset: this.idService,
                platformType: this.form.platformType,
                version: this.form.version,
                sdk: this.form.file
              };
              _context.p = 1;
              _context.n = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 2000);
              });
            case 2:
              _context.n = 3;
              return this.uploadSDK(payload);
            case 3:
              data = _context.v;
              if (data) {
                this.$buefy.toast.open({
                  message: this.uploadTexts.success,
                  position: 'is-top',
                  type: 'is-success'
                });
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error('Erro ao enviar SDK:', _t);
              this.$buefy.toast.open({
                message: this.uploadTexts.error,
                position: 'is-top',
                type: 'is-danger'
              });
            case 5:
              _context.p = 5;
              this.loading = false;
              this.close();
              this.getListSDKs();
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function saveSDK(_x) {
        return _saveSDK.apply(this, arguments);
      }
      return saveSDK;
    }()
  })
};